import React, { useState } from 'react';
import TalentsApi from "../../TalentsApi";
import Button from "../../components/reusableElementsComponents/Button";
import { ToastContainer, toast } from "react-toastify";
import * as Constants from "./../../constants";
import { FormControl, TextField, InputAdornment } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { t } from '../../content';

function ChangePassword() {
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);

  const [newPassword, setNewPassword] = useState("");
  const [newPasswordVisible, setNewPasswordVisible] = useState(false);

  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const [errors, setErrors] = useState({
      password: false,
      new_password: false,
      confirm_password: false
  });

  const handleBlurNewPassword = () => {
      let valid = Constants.VALID_PASSWORD.test(newPassword);
      if (valid) {
          setErrors(prevErrors => ({
              ...prevErrors,
              new_password: false
          }));
      }
      else {
          setErrors(prevErrors => ({
              ...prevErrors,
              new_password: true
          }));
      }
  }

  const handleBlurConfirmPassword = () => {
      if (newPassword !== confirmPassword) {
          setErrors(prevErrors => ({
              ...prevErrors,
              confirm_password: true
          }));
      } else {
          setErrors(prevErrors => ({
              ...prevErrors,
              confirm_password: false
          }));
      }
  }
    
  function onSubmit(e) {
    e.preventDefault();
    if (!password || !newPassword || !confirmPassword) {
        toast.error(t('account.toasts.fillAllFields'));
        return;
    }
    let obj = new TalentsApi();
    const updatePasswordToast = toast.loading(t('account.toasts.updatingPassword'));
    obj
      .apiCall(
        "user/password/",
        "post",
        JSON.stringify({
          password: password,
          new_password: newPassword,
        })
      )
      .then((data) => {
        if(data?.httpStatus === 200){
            toast.update(updatePasswordToast, { render: t('account.toasts.passwordUpdated'), type: "success", isLoading: false, autoClose: '2000', closeButton: true, hideProgressBar: true });
            setPassword("");
            setPasswordVisible(false);
            setNewPassword("");
            setNewPasswordVisible(false);
            setConfirmPassword("");
            setConfirmPasswordVisible(false);
            setErrors({
                password: false,
                new_password: false,
                confirm_password: false
            });
        } else if(data?.json?.error && data?.json?.error?.code === 1002){
            toast.update(updatePasswordToast, { render: t('account.toasts.invalidCurrentPassword'), type: "error", isLoading: false, autoClose: '2000', closeButton: true, hideProgressBar: true });
            setErrors(prevErrors => ({
                ...prevErrors,
                password: true
            }));
        } else {
            toast.update(updatePasswordToast, { render: t('account.toasts.invalidValues'), type: "error", isLoading: false, autoClose: '2000', closeButton: true, hideProgressBar: true });
        }
      });
  }

  return (
      <div className="change-password-inner-div">
        <ToastContainer />
        <FormControl style={{ width: "100%", marginBottom: "20px" }}>
          <TextField
              placeholder={t('account.currentPassword')}
              id="password"
              name="password"
              type={ passwordVisible ? "text" : "password"}
              autoComplete="on"
              value={password}
              InputProps={{
                  endAdornment: (
                      <InputAdornment position="end">
                          <button type="button" onClick={() => setPasswordVisible(!passwordVisible)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                              {passwordVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                          </button>
                      </InputAdornment>
                  ),
              }}
              variant="standard"
              onChange={(e) => {
                  setPassword(e.target.value)
                  setErrors(prevErrors => ({
                      ...prevErrors,
                      password: false
                  }));
              }}
          />
        </FormControl>
        {errors.password &&
            <div>
                <p style={{ color: "red" }}>{t('account.wrongPassword')}</p>
            </div>
        }
        <br />
        <FormControl style={{ width: "100%", marginBottom: "20px" }}>
            <TextField
                placeholder={t('account.newPassword')}
                id="new_password"
                name="new_password"
                type={ newPasswordVisible ? "text" : "password"}
                autoComplete="on"
                value={newPassword}
                onBlur={handleBlurNewPassword}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <button type="button" onClick={() => setNewPasswordVisible(!newPasswordVisible)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                                {newPasswordVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                            </button>
                        </InputAdornment>
                    ),
                }}
                variant="standard"
                onChange={(e) => {
                    setNewPassword(e.target.value);
                    setErrors(prevErrors => ({
                        ...prevErrors,
                        new_password: false
                    }));
                }}
            />
        </FormControl>
        {errors.new_password &&
            <div>
                <p style={{ color: "red" }}>{t('validation.passwordInstruction')}</p>
            </div>
        }
        <br />
        <FormControl style={{width: "100%", marginBottom: "20px" }}>
            <TextField
                placeholder={t('common.placeholders.confirmPassword')}
                id="confirm_password"
                name="confirm_password"
                type={ confirmPasswordVisible ? "text" : "password"}
                autoComplete="on"
                value={confirmPassword}
                onBlur={handleBlurConfirmPassword}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <button type="button" onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                                {confirmPasswordVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                            </button>
                        </InputAdornment>
                    ),
                }}
                variant="standard"
                onChange={(e) => {
                    setConfirmPassword(e.target.value);
                    setErrors(prevErrors => ({
                        ...prevErrors,
                        confirm_password: false
                    }));
                }}
            />
        </FormControl>
        {errors.confirm_password &&
            <div>
                <p style={{ color: "red" }}>{t('account.toasts.passwordMustBeSame')}</p>
            </div>
        }
        <br />
        <div className='d-flex justify-content-center'>
            <Button btnstyle={'mazhrBtn default-green white'} onClick={onSubmit} disabled={errors.new_password || errors.confirm_password}>
                {t('account.changePassword')}
            </Button>
        </div>
      </div>
    );
}

export default ChangePassword;
